import useHeaders from "../utils/useHeaders";
import { URI_API } from "../utils/api";

// Get all hospitals
const getAllHospitals = async () => {
  return await fetch(`${URI_API}/hospital_area/all`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

// Get all active hospital areas
const getAllActiveAreas = async () => {
  return await fetch(`${URI_API}/hospital_area/all/areas_active`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getAllAreas = async () => {
  return await fetch(`${URI_API}/hospital_area/all/areas`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getAllAreasPerHospital = async () => {
  return await fetch(`${URI_API}/hospital_area/all/areas_active`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getAllActiveHospitals = async () => {
  return await fetch(`${URI_API}/hospital_area/all/active`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const getHospitalInfoPerName = async (name: string) => {
  return await fetch(`${URI_API}/hospital_area/name/${name}`, {
    method: "GET",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

const createHospital = async (body: any) => {
  return await fetch(`${URI_API}/hospital_area/create`, {
    method: "POST",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(body),
  }).then((res) => res.json());
};

const editHospital = async (hospitalId: number, body: any) => {
  return await fetch(`${URI_API}/hospital_area/edit/${hospitalId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
    body: JSON.stringify(body),
  }).then((res) => res.json());
};

const deactivateHospital = async (hospitalId: number) => {
  return await fetch(`${URI_API}/hospital_area/deactivate/${hospitalId}`, {
    method: "PUT",
    headers: useHeaders.getHeaders(),
  }).then((res) => res.json());
};

export default {
  getAllHospitals,
  getAllActiveAreas,
  getAllAreas,
  getAllActiveHospitals,
  getHospitalInfoPerName,
  getAllAreasPerHospital,
  createHospital,
  editHospital,
  deactivateHospital,
};
